import { ReactElement } from 'react';
import { Typography } from 'antd';

const { Title: AntTitle, Paragraph } = Typography;

const Title = (): ReactElement => {
  return (
    <>
      <AntTitle level={1}>モニター可能数変更</AntTitle>
      <Paragraph type='secondary'>現在のモニター可能数を確認し、必要に応じて変更することができます。</Paragraph>
    </>
  );
};

export default Title;
